module.exports = __webpack_public_path__ + "fonts/NeuePlak-CompBold.e0e85f37.eot";